<template>
    <v-combobox
            ref="searchInput"
            flat
            clearable
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Ocupacion no encontrada' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="description"
            item-value="id"
            label="Ocupacion"
            @click:clear="clearSearch"
            return-object
    >
        <template slot="no-data">
            <span class="caption pa-2">Ocupacion no encontrada
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    v-if="currentProvider"
                    depressed
                    @click="createOccupation">crearla</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content v-text="data.item.description"></v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'providerId'],
        data(){
            return {
                descriptionLimit: 60,
                occupations: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
          this.getOccupations()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
            },
            async createOccupation(){
                var vm =this

                if(vm.search.length < 3){
                    vm.showSnackBar('La ocupacion debe contener al menos 3 caracteres')
                    return
                }

                const providerId = vm.providerId || vm.currentProvider && vm.currentProvider.id
                if(!providerId){
                  return
                }

                 vm.loadingCreate = true
                const response = await ApiUtils.makePost(`providers/${providerId}/occupation`, {
                    description: vm.search
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando crear la ocupacion')
                    return
                }

                const json = await response.json()
                vm.occupations.push(json.result.occupation)
                vm.$nextTick(function(){
                    const createdModel = {
                        id: json.result.occupation.id,
                        description: json.result.occupation.description,
                    }
                    vm.model = createdModel
                    vm.$emit('change', createdModel)
                            vm.$nextTick(function(){
                                vm.$refs.searchInput.blur()
                            })
                })

            },
            debounceGetOccupations: debounce(function(){
                this.getOccupations()
            }, 300),
            async getOccupations(){

                var vm = this

                const providerId = vm.providerId || vm.currentProvider && vm.currentProvider.id
                if(!providerId){
                  return
                }

                if(!providerId){
                    throw new Error('No provider selected')
                }

                vm.loading = true
                const response = await ApiUtils.makeGet(`public/providers/${providerId}/occupations`, {
                    term: vm.search
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando ocupaciones')
                    return
                }

                const json = await response.json()
                vm.occupations = json.result.occupations.data

               vm.$nextTick(function(){
                   if(vm.value && vm.value.id){
                       if (!vm.occupations.find(o => o.id === vm.value.id)) {
                           vm.occupations.push(vm.value)
                       }
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.occupations.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.occupations.map(occupation => {
                    return {
                        id: occupation.id,
                        description: occupation.description,
                    }
                })
            }
        },
        watch: {
            search (val) {

                var vm = this
                if(vm.model && val === vm.model.description) return
                vm.model = null
                vm.debounceGetOccupations()
            },
            model(val){

                const newModel = typeof val === 'string' ? null : val
                this.$emit('change', newModel)
                this.search = newModel && newModel.description || ''
            },
            value(val){

                var vm = this
                if (val && !vm.occupations.find(o => o.id === vm.value.id)) {
                    vm.occupations.push(vm.value)
                }
                vm.model = val
            }
        }
    }
</script>
